import React, { Component } from 'react';
import {
    Grid,
    FormControl
} from "@material-ui/core";
import WrappedAutocomplete from './WrappedAutocomplete';

class SelectClient extends Component {

    render() {
        let { specificsClients } = this.props

        return (
            <Grid item container>
                <FormControl variant="outlined" fullWidth>
                    <WrappedAutocomplete
                        label={"client"}
                        placeholder={"client"}
                        name="selectedClient"
                        value={this.props.selectedClient}
                        options={specificsClients}
                        onChange={this.props.handleChange}
                        getOptionLabel={option => option.name ? option.name : ""}
                        getOptionSelected={(option, value) => option.id === value.id}
                        renderOption={option => (
                            <React.Fragment>
                                {option.name ? option.name : ""}
                            </React.Fragment>
                        )}
                    />
                </FormControl>
            </Grid>
        );
    }
}

export default SelectClient;
